import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import Layout from "app/layout/Layout";
import colors from "app/styles/colors";
import ImageEditorCombine from "app/components/Editors/ImageEditorCombine";
import TextEditorCombine from "app/components/Editors/TextEditorCombine";
import { PrimaryButton } from "app/components/Buttons/Button";
import { checkCharacterValidation, checkImageValidation } from "app/utils";
import FreightsServices from "app/apis/Freights/FreightsServices";
import { ErrorToaster } from "app/components/Toaster/Toaster";
import { LoadingCircle } from "app/components/UI/Loader";

let characterLength = {
  mainContent: 450,
  subContent: 230,
};

function SeaFreight() {
  const [allImages, setAllImages] = useState({});
  const [allContents, setAllContents] = useState({});
  const [itemData, setItemData] = useState({});
  const [loader, setLoader] = useState(true);

  const handleDataSubmission = async () => {
    try {
      if (
        checkCharacterValidation(
          characterLength.mainContent,
          allContents?.mainContent?.length,
          "Main Content"
        ) &&
        checkCharacterValidation(
          characterLength.mainContent,
          allContents?.secondMainContent?.length,
          "Second Main Content"
        ) &&
        checkCharacterValidation(
          characterLength.subContent,
          allContents?.subSectionFirst?.length,
          "Section First Content"
        ) &&
        checkCharacterValidation(
          characterLength.subContent,
          allContents?.subSectionSecond?.length,
          "Section Second Content"
        ) &&
        checkImageValidation(allImages?.bannerImage, "Main Banner") &&
        checkImageValidation(allImages?.firstImage, "First") &&
        checkImageValidation(allImages?.subFirstImage, "First section") &&
        checkImageValidation(allImages?.subSecondImage, "Second section")
      ) {
        let formData = new FormData();
        {
          itemData?.id && formData.append("id", itemData?.id);
        }

        formData.append("description", allContents?.mainContent?.text);
        formData.append(
          "second_description",
          allContents?.secondMainContent?.text
        );
        formData.append(
          "section_first_description",
          allContents?.subSectionFirst?.text
        );
        formData.append(
          "section_second_description",
          allContents?.subSectionSecond?.text
        );

        if (typeof allImages?.bannerImage == "object") {
          formData.append(
            "banner_image",
            allImages?.bannerImage,
            allImages?.bannerImage?.name
          );
        }
        if (typeof allImages?.firstImage == "object") {
          formData.append(
            "first_image",
            allImages?.firstImage,
            allImages?.firstImage?.name
          );
        }
        if (typeof allImages?.subFirstImage == "object") {
          formData.append(
            "section_first_image",
            allImages?.subFirstImage,
            allImages?.subFirstImage?.name
          );
        }
        if (typeof allImages?.subSecondImage == "object") {
          formData.append(
            "section_second_image",
            allImages?.subSecondImage,
            allImages?.subSecondImage?.name
          );
        }

        if (itemData?.id) {
          await FreightsServices.update("SeaFreight", formData);
        } else {
          await FreightsServices.create("SeaFreight", formData);
        }
        setLoader(true);
      }
    } catch (error) {
      ErrorToaster(error);
      console.log("🚀 ~ handleDataSubmission ~ error:", error);
    }
  };

  const getItemData = async () => {
    let res = await FreightsServices.get("SeaFreight");
    let data = res?.data[0];
    setItemData(data);
    setAllContents({
      mainContent: {
        text: data?.description,
        length: data?.description?.length,
      },
      secondMainContent: {
        text: data?.second_description,
        length: data?.second_description?.length,
      },
      subSectionFirst: {
        text: data?.section_first_description,
        length: data?.section_first_description?.length,
      },
      subSectionSecond: {
        text: data?.section_second_description,
        length: data?.section_second_description?.length,
      },
    });
    setAllImages({
      bannerImage: data?.banner_image,
      firstImage: data?.first_image,
      secondImage: data?.second_image,
      subFirstImage: data?.section_first_image,
      subSecondImage: data?.section_second_image,
    });
    setLoader(false);
  };

  useEffect(() => {
    if (loader) {
      getItemData();
    }
  }, [loader]);
  return (
    <Layout>
      <Box
        sx={{ backgroundColor: colors.lightGray, p: 3, borderRadius: "12px" }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Sea Freight Management
            </Typography>
          </Grid>
        </Grid>
        {loader ? (
          <LoadingCircle />
        ) : (
          <Box sx={{ mt: 2 }}>
            <ImageEditorCombine
              title={"Banner Image"}
              handleData={(e) => setAllImages({ ...allImages, bannerImage: e })}
              uploadedImage={allImages?.bannerImage}
            />
            <TextEditorCombine
              title="Main Content"
              characterLimit={characterLength.mainContent}
              data={itemData?.description}
              handleData={(e, contentLength) =>
                setAllContents({
                  ...allContents,
                  mainContent: {
                    text: e,
                    length: contentLength,
                  },
                })
              }
            />
            <ImageEditorCombine
              title={"First Image"}
              handleData={(e) => setAllImages({ ...allImages, firstImage: e })}
              uploadedImage={allImages?.firstImage}
            />
            <TextEditorCombine
              title="Second Main Content"
              characterLimit={characterLength.mainContent}
              data={itemData?.second_description}
              handleData={(e, contentLength) =>
                setAllContents({
                  ...allContents,
                  secondMainContent: {
                    text: e,
                    length: contentLength,
                  },
                })
              }
            />
            <TextEditorCombine
              title="Sub Section First Content"
              characterLimit={characterLength.subContent}
              data={itemData?.section_first_description}
              handleData={(e, contentLength) =>
                setAllContents({
                  ...allContents,
                  subSectionFirst: {
                    text: e,
                    length: contentLength,
                  },
                })
              }
            />
            <ImageEditorCombine
              title={"Sub Section First Image"}
              handleData={(e) =>
                setAllImages({ ...allImages, subFirstImage: e })
              }
              uploadedImage={allImages?.subFirstImage}
            />
            <TextEditorCombine
              title="Sub Section Second Content"
              characterLimit={characterLength.subContent}
              data={itemData?.section_second_description}
              handleData={(e, contentLength) =>
                setAllContents({
                  ...allContents,
                  subSectionSecond: {
                    text: e,
                    length: contentLength,
                  },
                })
              }
            />
            <ImageEditorCombine
              title={"Sub Section Second Image"}
              handleData={(e) =>
                setAllImages({ ...allImages, subSecondImage: e })
              }
              uploadedImage={allImages?.subSecondImage}
            />
            <PrimaryButton
              title="Save"
              onClick={() => handleDataSubmission()}
              style={{
                margin: "10px 0px",
              }}
            />
          </Box>
        )}
      </Box>
    </Layout>
  );
}

export default SeaFreight;
